import React from 'react';

export default function SvgEmailIcon(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="currentColor" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 2.5C1.72386 2.5 1.5 2.72386 1.5 3V9C1.5 9.27614 1.72386 9.5 2 9.5H10C10.2761 9.5 10.5 9.27614 10.5 9V3C10.5 2.72386 10.2761 2.5 10 2.5H2ZM0.5 3C0.5 2.17157 1.17157 1.5 2 1.5H10C10.8284 1.5 11.5 2.17157 11.5 3V9C11.5 9.82843 10.8284 10.5 10 10.5H2C1.17157 10.5 0.5 9.82843 0.5 9V3Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.577997 3.2319C0.7261 2.99883 1.0351 2.92996 1.26817 3.07806L5.75157 5.92704C5.82611 5.97346 5.91217 5.99807 6 5.99807C6.08782 5.99807 6.17387 5.97347 6.24841 5.92706L10.7318 3.07806C10.9649 2.92996 11.2739 2.99883 11.422 3.2319C11.5701 3.46497 11.5012 3.77397 11.2682 3.92207L6.78317 6.77207C6.78227 6.77264 6.78137 6.77321 6.78047 6.77377C6.54653 6.92034 6.27606 6.99807 6 6.99807C5.72395 6.99807 5.45347 6.92034 5.21954 6.77377C5.21864 6.77321 5.21774 6.77264 5.21684 6.77207L0.731839 3.92207C0.498772 3.77397 0.429895 3.46497 0.577997 3.2319Z"
                fill="currentColor"
            />
        </svg>
    );
}
